import { studio } from "@/lib/studioApi";
import { uploadPhoto } from "@/lib/photos";

const DB_NAME = "devisto_offline";
const STORE = "photos";

const open = () =>
  new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE)) {
        request.result.createObjectStore(STORE, { keyPath: "id" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

const tx = async (mode, run) => {
  const db = await open();
  return new Promise((resolve, reject) => {
    const store = db.transaction(STORE, mode).objectStore(STORE);
    const request = run(store);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

export const savePhotoOffline = (dossierId, file, category) =>
  tx("readwrite", (store) => store.put({
    id: `photo-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    dossierId,
    category,
    name: file.name || "photo.jpg",
    type: file.type || "image/jpeg",
    blob: file,
    created_at: new Date().toISOString(),
  }));

export const offlinePhotos = async () => {
  try { return (await tx("readonly", (store) => store.getAll())) || []; } catch (e) { return []; }
};

export const offlinePhotoCount = async () => (await offlinePhotos()).length;

let flushing = false;

export const flushPhotos = async () => {
  if (flushing) return { synced: 0, failed: 0 };
  const items = await offlinePhotos();
  if (!items.length) return { synced: 0, failed: 0 };
  flushing = true;
  const token = localStorage.getItem("devisto_token");
  let synced = 0;
  let failed = 0;
  for (const item of items) {
    try {
      const file = new File([item.blob], item.name, { type: item.type });
      const media = await uploadPhoto(file, { token });
      await studio.post(`/dossiers/${item.dossierId}/photos`, { media_id: media.id, category: item.category });
      await tx("readwrite", (store) => store.delete(item.id));
      synced += 1;
    } catch (e) {
      failed += 1;
    }
  }
  flushing = false;
  return { synced, failed };
};
